import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface OrderingPolicyIdControlProps {
  name: string;
  id: string;
}

export function OrderingPolicyIdControl({
  name,
  id,
}: OrderingPolicyIdControlProps): JSX.Element {
  const { errors, control } = useFormContext();

  const isEmptyValue = (value: string): boolean | string =>
    value.trim() !== '' || 'Order Policy ID is required';

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      maxLength={100}
      aria-label={name}
      inputSize="medium"
      blockWidth
      placeholder="Enter Contentful ID, e.g. MLI0YRMCJh2j3dTYRC2RZ"
      label=""
      rules={{
        required: 'Order Policy ID is required',
        validate: {
          isEmpty: isEmptyValue,
        },
      }}
    />
  );
}
